import { addAppApi, storageFileComplete, updateAppApi } from '@/services/signAndPayment';
import { Form, Input, Modal, message, Image, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { PlusOutlined, CloseCircleFilled } from '@ant-design/icons';
import { useUpload } from '@/hooks';

interface Props {
  data: any;
  visible: boolean;
  editType: number;
  handleCancel: () => void;
}
const AppModal = (props: Props) => {
  const { data, visible, editType, handleCancel } = props;

  const [form] = Form.useForm();
  const [iconFile, setIconFile] = useState<any[]>([]);
  const { uploadRequest } = useUpload();

  useEffect(() => {
    if (editType === 1 && data?.iconUrl) {
      setIconFile([{ fileStorageId: data.icon, fileUrl: data.iconUrl }]);
    }
  }, []);

  const onHandleSubmit = async (data: any) => {
    if (editType === 0) {
      const res = await addAppApi(data);
      if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
        message.info('应用添加成功');
        handleCancel();
      }
    } else {
      const res = await updateAppApi(data.appId, data);
      if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
        message.info('应用更新成功');
        handleCancel();
      }
    }
  };

  const handleFormSubmit = () => {
    form.validateFields().then(async (values) => {
      onHandleSubmit({
        ...values,
        icon: iconFile && iconFile.length > 0 ? iconFile[0].fileStorageId : '',
      });
    });
  };

  const getBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const uploadFile = (files: any, callback: Function) => {
    uploadRequest({
      url: '/storage/v1/objects/upload/presigned',
      fileStream: files,
      appName: 'order',
      policy: 1,
      srcShortName: files.name,
      srcFileSuffix: files?.name?.split('.')?.pop() ?? 'png',
      srcFullPath: '/app/',
      srcFileSize: files?.size,
      onPreload: () => {},
      onProgress: () => {},
      onSuccess: async (res: any) => {
        const { file, storage } = res ?? {};
        file.fileUrl = await getBase64(file);
        file.fileStorageId = storage?.storageFileId;
        callback?.(file);
        storageFileComplete(storage?.storageFileId);
        // cloudModel.putComplete(storage?.storageFileId);
      },
      onError: async (err: any) => {
        const { exists, file, storage } = err ?? {};
        if (exists) {
          file.fileUrl = await getBase64(file);
          file.fileStorageId = storage?.storageFileId;
          callback?.(file);
          // cloudModel.putComplete(storage?.storageFileId);
        }
      },
    });
  };
  const iconProp = {
    showUploadList: false,
    maxCount: 1,
    accept: '.jpg,.jpeg,.png',
    beforeUpload(f: any) {
      if (iconFile?.length > 1) {
        message.info('最多上传1个文件');
        return false;
      }
      uploadFile(f, (file: any) => {
        setIconFile([file]);
      });
    },
  };

  const deleteIconFile = () => {
    setIconFile([]);
  };

  return (
    <Modal
      open={visible}
      title={editType === 1 ? '编辑应用' : '添加应用'}
      onCancel={handleCancel}
      maskClosable={false}
      onOk={handleFormSubmit}
    >
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        form={form}
        initialValues={data}
      >
        <Form.Item
          label="应用名称"
          name="name"
          rules={[{ required: true, message: '请输入应用名称' }]}
        >
          <Input maxLength={50} placeholder="请输入应用名称" />
        </Form.Item>
        <Form.Item
          label="应用标识"
          name="code"
          rules={[{ required: true, message: '请输入应用标识' }]}
        >
          <Input maxLength={50} placeholder="请输入应用标识" />
        </Form.Item>
        <Form.Item
          label="应用ID"
          name="appId"
          rules={[{ required: true, message: '请输入应用ID，只能保护字母或数字' }]}
        >
          <Input maxLength={36} disabled={editType === 1} placeholder="请输入应用ID" />
        </Form.Item>
        <Form.Item
          label="应用Secret"
          name="secret"
          rules={[{ required: true, message: '请输入应用Secret' }]}
        >
          <Input maxLength={64} placeholder="请输入应用Secret" />
        </Form.Item>
        <Form.Item label="应用图标" name="icon">
          {iconFile && iconFile.length > 0 ? (
            <div className="iconFile">
              <CloseCircleFilled className="closeIcon" onClick={deleteIconFile} />
              <Image height={100} src={iconFile[0].fileUrl} />
            </div>
          ) : (
            <Upload {...iconProp} listType="picture-card">
              <div>
                <PlusOutlined />
              </div>
            </Upload>
          )}
        </Form.Item>
        <Form.Item label="应用描述" name="description">
          <Input.TextArea maxLength={100} placeholder="请输入应用描述" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default AppModal;
